export enum enCourseType {
  course = 1,
  package = 2,
}

export interface ICourseLike {
  id: number;
  status: boolean;
  courseId: number;
  userId: number;
}

export interface ICourse {
  id: number;
  title: string;
  description: string;
  offer_description?: string;
  access_type: number;
  type?: enCourseType;
  logo?: string;
  slug: string;
  published: number;
  hash: string;
  default_thumb?: string;
  progress_bar: number;
  progress_percent?: number;
  offer: number;
  fc_pixel?: string;
  gl_analytics?: string;
  allow_manual_watch: number;
  disable_comments: number;
  disable_lesson_counter: number;
  terms_content: string;
  is_my?: boolean;
  release_at?: string;
  support_external_url?: string;
  certificate_url?: string;
  expire_at: string;
  secretary_status: boolean;
  secretary_url: string;
  have_active_community: boolean;
  depoimentu_url: string;
  has_certificate?: boolean;
  matriculation_date: string;
  customizations: {
    avatar?: string;
    image_cover?: string;
    cover_background_color: string;
    description_color: string;
    header_background_color: string;
    header_link_color: string;
    layout: number;
    login_background_image: string;
    logo_login: string;
    theme: number;
    title_color: string;
  };
  category: {
    id: number;
    name: string;
  };
  producer: {
    id: number;
    id_leg: number;
    name: string;
    email: string;
    business_name: string;
    avatar?: string;
  };
  author: {
    id?: number;
    name: string;
    avatar?: string;
    description?: string;
  };
  total_modules: number;
  total_lessons: number;
  share: string;
  status: enStatus;
  blocked_by: enStatus;
  offer_url: string;
  is_free: boolean;
  days_available: number;

  //----
  error?: any;
  progress?: {
    percentage: number;
    certificate?: {
      url: string;
    };
  };
  news?: {
    id: number;
    id_course: number;
    title: string;
    content: string;
    published: number;
    slug: string;
    created_at: string;
  }[];
}

export interface IModule {
  id: number;
  title: string;
  status: enStatus;
  release: string;
  isFetchingLessons: boolean;
  total_lessons: number;
  lessons: ILesson[];
}

export interface ILessonKeepWatching {
  id: number;
  watched: boolean;
  status: enStatus;
}

export interface ILesson {
  id: number;
  id_course: number;
  id_module: number;
  hash_course: string;
  title: string;
  image?: string;
  short_description: string;

  watched: boolean;
  author: {
    id?: number;
    name?: string;
    avatar?: string;
  };
  lesson_type: {
    id: number;
    name: string;
  };
  status: enStatus;
  release: string;
  has_file: boolean;
}

export interface ICommunity {
  id: number;
  url: string;
}

export enum enThemeNetflix {
  BLACK = 0,
  WHITE = 1,
}

export enum enLayout {
  CLASSIC = 0,
  NETFLIX = 1,
  PORTAL = 2,
}

export type enCourseStatus =
  | 'producer'
  | 'learner'
  | 'free'
  | 'something_free'
  | 'must_accept_term'
  | 'not_released'
  | 'expired'
  | 'blocked'
  | 'offer';

export enum enStatus {
  PRODUCER = 'producer',
  LEARNER = 'learner',
  FREE = 'free',
  SOMETHING_FREE = 'something_free',
  MUST_ACCEPT_TERM = 'must_accept_term',
  NOT_RELEASED = 'not_released',
  EXPIRED = 'expired',
  BLOCKED = 'blocked',
  OFFER = 'offer',
  NOT_PURCHASED = 'not_purchased',
}

export const blockedStatus = [enStatus.BLOCKED, enStatus.EXPIRED, enStatus.NOT_RELEASED, enStatus.MUST_ACCEPT_TERM];
export const negativeStatus = [enStatus.BLOCKED, enStatus.EXPIRED, enStatus.NOT_RELEASED, enStatus.MUST_ACCEPT_TERM];
